import { constants } from "../../../constants";

export default class DepositCompleted {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default() {
        this.gb.emitters.emit.game.depositCompleted();
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.walletProtocol) {
            case constants.EXCITE:
                event["depositCompleted"] = this._default
                break;
            default:
                event["depositCompleted"] = this._default
        }

        return event;
    }
}
